// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jh-3";
export var downloadButton = "_jh-4";
export var fileContainer = "_jh-9 _jh-7";
export var fileContainerBase = "_jh-7";
export var fileContainerFixedHeight = "_jh-8 _jh-7";
export var fileInfo = "_jh-5";
export var fileInfoWidthRestricted = "_jh-6";
export var fileType = "_jh-1";
export var fileTypeName = "_jh-2";
export var image = "_jh-0";
export var link = "_jh-b";
export var overflowEllipsis = "_jh-a";